<template>
  <div>
    <div
      :class="
        !this.$store.getters.iframeColidee
          ? 'pageloader is-active has-text-centered'
          : 'pageloader-colidee is-active has-text-centered'
      "
    >
      <span
        v-if="!this.$store.getters.iframeColidee"
        class="title"
        v-html="$t('loading.licence')"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    // on récupère un éventuel initSearch depuis l'URL et on le stocke dans le store state si il existe
    var initSearch = this.readinitSearchUrlHashParams()
    if (initSearch) {
      this.$store.dispatch('setInitSearch', { initSearch: initSearch })
    } else {
      this.$store.dispatch('setInitSearch', { initSearch: '' })
    }

    /* on récupère un éventuel token depuis l'URL et on le stocke dans le store state si il existe */
    var tokenURL = this.readUrlHashParams()
    if (tokenURL) {
      this.$store.dispatch('setTokenURL', { tokenURL: tokenURL })
    }
    /* On teste si le token  est vide dans le store (vide = pas de token en URL ou pas de token en mémoire localstorage) - on  vire le gars vers APPYPACK */
    if (!this.$store.getters.userToken) {
      window.location = process.env.URL_SSO_FRONT
    } else {
      /* on fait une demande de récupération de user/me avec ce token de connexion 'mis à jour ou en mémoire'	*/
      this.$store.dispatch('requireAuth')
    }
  },
  methods: {
    // change lang
    choosenLanguageFunction (value) {
      var selectlangue = value
      this.$i18n.locale = value
      this.$store.dispatch('changeLangue', selectlangue)
      this.$store.commit('UPDATE_CHOOSEN_LANGUAGE_CLIENT', selectlangue)
    },
    // on veut récupérer la liste des sondages avec le token
    readUrlHashParams () {
      var urlString = window.location.href
      var url = new URL(urlString)
      var token = url.searchParams.get('t')
      var idEntreprise = url.searchParams.get('e')
      var idPlateforme = url.searchParams.get('p')
      var langColidee = url.searchParams.get('l')
      if (idEntreprise && idPlateforme) {
        this.choosenLanguageFunction(langColidee)
        this.$store.dispatch('setIframeColidee', true)
      } else {
        this.$store.dispatch('setIframeColidee', false)
      }
      this.$store.dispatch('setIdEntrepriseIdPlateforme', {
        idEntreprise: idEntreprise,
        idPlateforme: idPlateforme
      })
      if (token) {
        return token
      }
    },
    // on recherche un sondage précis
    readinitSearchUrlHashParams () {
      var urlString = window.location.href
      var url = new URL(urlString)
      var initSearch = url.searchParams.get('initSearch')
      if (initSearch) {
        return initSearch
      }
    }
  }
}
</script>

<style scoped>
.pageloader {
  background: #424a60 !important;
}
.pageloader-colidee {
  background: #e6ecf0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/security/tokenLogin.vue